import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


function MobileHeaderInner({userData, refreshPrivateData }){
  const [isLoggedIn] = useState(!!localStorage.getItem('token'));
  const [isRefreshing, setIsRefreshing] = useState(false);
  
  const OpenTabBar = () => {
  const aside = document.querySelector('.sidebar');
  if (aside) {
    aside.classList.add('main-nav-open');
  } else {
    console.warn("Sidebar element not found when trying to open tab bar");
  }
};
const handleRefreshBalance = async () => {
    if (!refreshPrivateData || isRefreshing) return;
    try {
      setIsRefreshing(true);
      await refreshPrivateData();
    } catch (err) {
      console.error('Error refreshing balance:', err);
    } finally {
      setTimeout(() => setIsRefreshing(false), 800);
    }
  };
   const [logo, setLogo] = useState([]);
      useEffect(() => {
          const fetchPromotions = async () => {
              try {
                  const response = await fetch(`${process.env.REACT_APP_API_URL}/api/logo`);
                  if (!response.ok) {
                      throw new Error("Failed to fetch promotions");
                  }
                  const data = await response.json();
                  setLogo(data[0].logo);
              } catch (error) {
                  console.error("Error fetching promotions:", error);
              }
          };
  
          fetchPromotions();
      }, []);
  


        const host = window.location.hostname.toLowerCase();
        const isRocket88 = host.includes('rocket88');
        return(
          <div className={`home-header-wrap ${isRocket88 ? 'rocket88' : ''}`}>
            <div className="header-content" id="home-header-content">
              <div className="header-left">
                <div onClick={() => OpenTabBar()} className="header-menu">
                  <svg className="am-icon am-icon-icon-menu_2f6ab48a am-icon-md auto-icon"><use xlinkHref="#icon-menu_2f6ab48a" /></svg>
                </div>
                <div className="header-logo"><img className="common-logo" src={`${process.env.REACT_APP_API_URL}/storage/${logo}`} alt="Logo" /></div>
              </div>
              {!isLoggedIn ?(
              <div className="header-right">
                <div className="login-register">
                  <Link to={"/login"} className="nav-btn login-btn"><span>Login</span></Link>
                  <Link to={"/signup"} className="nav-btn register-btn"><span>Register</span></Link>
                </div>
              </div>
              ):(
              <div className="header-right">
            <div className="user-info">
              <div className="user-balance">
                <div className="member-balance">
                  <div className="sum-balance"><span className="symbol">৳</span><span className="amount">{userData?.balance}</span></div>
                  <div className="balance-control">
                    <div  onClick={handleRefreshBalance} className={`refresh-balance ${isRefreshing ? 'rotating' : ''}`}>
                      <svg className="am-icon am-icon-icon-refresh_307bd577 am-icon-md"><use xlinkHref="#icon-refresh_307bd577" /></svg>
                    </div>
                  </div>
                </div>
              </div>
              <Link to={"/deposit"} className="header-btn deposit-btn"><img className="auto-icon" src="/icons/header/header-deposit.svg" alt="Deposit" loading="lazy" /></Link>
              <Link to={"/withdraw"} className="header-btn withdraw-btn"><img className="auto-icon" src="/icons/header/header-withdraw.svg" alt="Withdraw" loading="lazy" /></Link>
              <Link to={"/inbox"} className="header-btn mail-btn">
                <img className="auto-icon" src="/icons/header/header-mail.svg" alt="Inbox" loading="lazy" />
              </Link>
            </div>
          </div>
              )}

            </div>
          </div>
    );

}
export default MobileHeaderInner;